import React from 'react';
import PublicRoute from './PublicRoute';
import LoginContainer from 'components/Pages/Authentication/LoginContainer';
import Register from 'components/Pages/Authentication/Register';
import ForgotPassword from 'components/Pages/Authentication/ForgotPassword';
import NewPassword from 'components/Pages/Authentication/NewPassword';
import Verification from 'components/Pages/Authentication/Verification';
import { qlikClient } from 'constants/environmental';
import QlikSaasLogin from 'components/Pages/Authentication/LoginContainer/QlikSaasLogin';
import config from 'coeus.config';

const SAAS = config.saas_client === qlikClient.SAAS;

const getLoginRoutes = () => {
    if (SAAS) {
        return [
            <PublicRoute
                key="login"
                path="/login"
                exact
                component={QlikSaasLogin}
            />,
            <PublicRoute
                key="admin-login"
                path="/admin"
                exact
                component={LoginContainer}
            />,
        ];
    }
    return [
        <PublicRoute
            key="login"
            path="/login"
            exact
            component={LoginContainer}
        />,
    ];
};

const publicRoutes = () => {
    return [
        ...getLoginRoutes(),
        <PublicRoute
            key="register"
            path="/register"
            exact
            component={Register}
        />,
        <PublicRoute
            key="forgot-password"
            path="/forgot-password"
            exact
            component={ForgotPassword}
        />,
        <PublicRoute
            key="new-password"
            path="/users/new-password/:token"
            exact
            component={NewPassword}
        />,
        <PublicRoute key="verify" path="/verify" component={Verification} />,
    ];
};

export default publicRoutes;
